import {useEffect, useState} from "react";
import ApiDatabase from "server";
import Table from "../../../../../components/table/table";
import EmptyState from "../../../../../components/EmptyState/EmptyState";
import Pagination from "../../../../../components/pagination/pagination";
import UseContext from "../../../../../hooks/useContext";

const BodyVivierRatingTempWorker = ({treated, search}) => {
    const {reviewUntreatedDelete} = UseContext()
    const [ratings, setRatings] = useState([])
    const token = localStorage.getItem('xsrfToken')
    const [isWaiting, setIsWaiting] = useState(true);
    const [currentPage, setCurrentPage] = useState(1)
    const [limitElement, setLimitElement] = useState(25)
    const [totalPages, setTotalPages] = useState(0)
    const [countPerPage, setCountPerPage] = useState(0)
    const [countTotal, setCountTotal] = useState(0)
    let reviewSearch = null;

    const getRatings = () => {
        setIsWaiting(true)
        setRatings([])
        if(treated) {
            ApiDatabase.getRatingTreatedTempWorkers({token, search: search, limit: limitElement, page: currentPage}, (data)=>{
                setRatings(data.reviews)
                setTotalPages(data.countPages)
                setCountPerPage(data.countPerPage)
                setCountTotal(data.count)

                setIsWaiting(false)
            },(err)=>{
                if (err.name !== "CanceledError") {
                    console.log(err)
                }
            })
        } else {
            ApiDatabase.getRatingUntreatedTempWorkers({token, search: search, limit: limitElement, page: currentPage}, (data)=>{
                setRatings(data.reviews)
                setTotalPages(data.countPages)
                setCountPerPage(data.countPerPage)
                setCountTotal(data.count)

                setIsWaiting(false)
            },(err)=> {
                if (err.name !== "CanceledError") {
                    console.log(err)
                }
            })
        }
    }

    useEffect(() => {
        getRatings()
    }, [treated, currentPage]);

    useEffect(() => {
        if (search) {
            reviewSearch = setTimeout(async () => {
                await getRatings();
            }, 400);
        } else {
            getRatings()
        }
        return () => clearTimeout(reviewSearch);
    }, [search])

    useEffect(() => {
        if(reviewUntreatedDelete) {
            setRatings(ratings.filter((review) => review._id !== reviewUntreatedDelete))
        }
    }, [reviewUntreatedDelete]);

    const titles = ['Intérimaire', 'Mission', 'Motif', 'Responsable'];

    return (
        <>
            <div className="flex flex-col w-full h-full overflow-hidden">
                <div className="flex-1 overflow-y-auto">
                    {isWaiting ? (
                        <div>
                            <table className="animate-pulse w-full animate-fadeIn">
                                <tbody>
                                    {
                                        [1, 2, 3, 4, 5].map((i, index)=>(
                                            <tr key={index}>
                                                {
                                                    titles?.map((title, index) => (
                                                        <td key={index} className={`py-7 ${index === 0 ? 'pl-4' : ''} ${index === titles.length - 1 ? 'pr-3' : 'px-2'}`}>
                                                            <div className="h-2 bg-gray-200 rounded"></div>
                                                        </td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            {ratings?.length > 0 ? (
                                <Table champsBody={ratings} champsHeader={titles} />
                            ) : (
                                <div className={'flex justify-center p-3'}>
                                    <EmptyState type={'avis_clients'}/>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {currentPage && totalPages > 1 && setCurrentPage ? (
                    <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
                        <Pagination
                            currentPage={currentPage}
                            countPerPage={countPerPage}
                            countTotal={countTotal}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>
                ) : null}
            </div>
        </>
    )
}

export default BodyVivierRatingTempWorker